/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActivityTagWithDelete } from "./getActivityTag";
import Button from "../../../Core/Components/CustomButton";
import PlusIcon from "../../../Common/Svgs/PlusIcon";
import {
  updateTrips,
  deleteActivityForStop,
} from "../../../Redux/Slices/trips.slice";
import LocationTypeSelector from "./CustomTripParts/LocationTypeSelector";
import LocationSelector from "./CustomTripParts/LocationSelector";
import ActivitySelector from "./CustomTripParts/ActivitySelector";
import CargoSelector from "./CustomTripParts/CargoSelector";
import Header from "./CustomTripParts/Header";

const CustomTripComponent = ({
  data,
  totalLength,
  currentIndex,
  // locations,
}) => {
  const dispatch = useDispatch();

  const { stops, validationForSteps, toastMessage } = useSelector(
    (state) => state.trips,
  );

  const [activity, setActivity] = useState({ key: 1 });
  const [cargo, setCargo] = useState({ key: 1 });

  const [locationTypeDropdown, setLocationTypeDropdown] = useState(false);
  const [locationDropdown, setLocationDropdown] = useState(false);
  const [activityDropdown, setActivityDropdown] = useState(false);
  const [cargoDropdown, setCargoDropdown] = useState(false);

  const handleActivityDeletion = (item, act) => {
    dispatch(
      deleteActivityForStop({
        itemId: item.id,
        activityId: act.id,
      }),
    );
    dispatch(
      updateTrips({
        key: "toastMessage",
        value: {
          ...toastMessage,
          visible: true,
          type: "activityDeleted",
          id: item.id,
        },
      }),
    );
  };

  const handleAddStop = () => {
    const updatedTrip = stops;

    const lastStopId = stops.length;
    const secondToLastIndex = lastStopId - 1;

    const newStop = {
      id: lastStopId,
      location: "Stop",
      locationId: lastStopId,
      activities: [],
      locationType: 1,
    };

    const updatedStops = updatedTrip.map((stop, index) => ({
      ...stop,
      id: index === secondToLastIndex ? stop.id + 1 : stop.id,
    }));

    updatedStops.splice(secondToLastIndex, 0, newStop);

    dispatch(
      updateTrips({
        key: "stops",
        value: updatedStops,
      }),
    );

    dispatch(
      updateTrips({
        key: "validationForSteps",
        value: {
          ...validationForSteps,
          step1: { ...validationForSteps.step1, stopLength: false },
        },
      }),
    );
  };

  const isStopActive = locationDropdown || activityDropdown || cargoDropdown;

  // update the dropdownActive (redux state) when any of the dropdown is open
  const updateDropdownActive = useCallback(() => {
    if (locationDropdown || activityDropdown || cargoDropdown) {
      dispatch(
        updateTrips({
          key: "dropdownActive",
          value: true,
        }),
      );
    } else {
      dispatch(
        updateTrips({
          key: "dropdownActive",
          value: false,
        }),
      );
    }
  }, [locationDropdown, activityDropdown, cargoDropdown, dispatch]);

  useEffect(() => {
    updateDropdownActive();
  }, [updateDropdownActive]);

  return (
    <div className="w-[643px] mb-3">
      <div
        className={`relative p-3 border hover:border-light-grey rounded-xl group ${
          isStopActive ? "border-light-grey" : "border-transparent"
        }`}
      >
        <Header
          data={data}
          totalLength={totalLength}
          setCargo={setCargo}
          setActivity={setActivity}
        />

        {/* select the type of location only for intermidiate stops and not for origin and dest */}
        <LocationTypeSelector
          data={data}
          totalLength={totalLength}
          open={locationTypeDropdown}
          setOpen={setLocationTypeDropdown}
        />

        <div className="mt-3">
          <p className="mb-1.5 font-aileron font-normal text-xs text-dark-gray capitalize">
            Location
          </p>

          <LocationSelector
            data={data}
            totalLength={totalLength}
            open={locationDropdown}
            setOpen={setLocationDropdown}
            setActivityDropdown={setActivityDropdown}
          />
          {validationForSteps.step1.location && data.location === "Stop" && (
            <p className="mt-1 text-xs font-normal font-aileron text-alert-red">
              Select a location to proceed
            </p>
          )}

          <div className="flex w-full mt-3 gap-x-3">
            <img src="/assets/icons/trips/big-indend.svg" alt="" />

            <div className="w-full">
              <ActivitySelector
                data={data}
                totalLength={totalLength}
                open={activityDropdown}
                setOpen={setActivityDropdown}
                activity={activity}
                handleClick={(e) => {
                  setActivity({ key: e.key, value: e.value });
                  setCargoDropdown(true);
                }}
              />
            </div>

            <div className="w-full">
              <CargoSelector
                data={data}
                totalLength={totalLength}
                open={cargoDropdown}
                setOpen={setCargoDropdown}
                activity={activity}
                setActivity={setActivity}
                cargo={cargo}
                setCargo={setCargo}
              />
            </div>
          </div>

          {/* error message for activity and cargo */}
          {data.id === 1 || data.id === totalLength
            ? null
            : validationForSteps.step1.activity.includes(data.id) && (
                <p className="mt-2 text-xs font-normal font-aileron text-alert-red">
                  Select an activity and a cargo combination to proceed
                </p>
              )}

          {data?.activities?.length ? (
            <div className="flex items-start pl-8 mt-3 gap-x-3">
              <img src="/assets/icons/trips/small-indend.svg" alt="" />

              <div className="flex flex-wrap w-[573px] gap-3 h-auto">
                {data.activities.map((act) => (
                  <div
                    className="flex items-center gap-x-2"
                    onClick={() => handleActivityDeletion(data, act)}
                  >
                    {getActivityTagWithDelete(
                      act?.activityId?.toString(),
                      act.cargo,
                    )}
                  </div>
                ))}

                <button
                  type="button"
                  className="flex items-center justify-center px-2 py-1 rounded-md bg-primary"
                  onClick={() => setActivityDropdown(true)}
                >
                  <PlusIcon className="w-4 h-4 stroke-white" />
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {currentIndex === totalLength - 2 ? (
        <div className="pb-3 mt-6 ml-3">
          <Button
            size="addStops"
            padding="addStops"
            width="dynamic"
            onClick={handleAddStop}
          >
            <div className="flex items-center gap-x-2">
              <PlusIcon className="w-4 h-4 stroke-white" />
              <p>Add Stop</p>
            </div>
          </Button>
        </div>
      ) : null}
    </div>
  );
};
export default CustomTripComponent;
